import App from "app";

//TODO: this is just a helper function which displays a backbone view in the current App
//TODO: in the long run we need to wrap provided view inside a 1-time Marionette.App which should be cleaned up by the consumer
//TODO: however we cannot use which approach until all existing imports like `import app from "App"` are gone
//TODO: for now we need to use global app, we have hundreds of usages of App.vent, App.module and this.listenTo(App.vent
export default function renderBackboneApp(view) {
    App.content.show(view);
}
